import { Api } from "./Api";
import { DocumentNonReconnu } from "../models/DocumentNonReconnu";
import _ from "lodash";
import axios from "axios";

export class DocumentNonReconnuApi extends Api {
    constructor() {
        super("document/non-reconnu");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            let res: Array<DocumentNonReconnu> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (d) {
                    return new DocumentNonReconnu(d);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    get(id: Number, params?: Object): Promise<DocumentNonReconnu> {
        return this.getResource(id, params).then(function (response) {
            return new DocumentNonReconnu(response.data.data);
        });
    }

    delete(id: Number, raison: string): Promise<DocumentNonReconnu> {
        return super.deleteResource(id, raison).then(function (response) {
            return new DocumentNonReconnu(response.data.data);
        });
    }

    reclasser(id: Number, type: Number): Promise<any> {
        return axios
            .post(this.apiUrl + id + "/reclasser", { type: type })
            .then(function (response) {
                return response.data;
            });
    }

    journaliser(id: Number): Promise<any> {
        return axios
            .post(this.apiUrl + id + "/journaliser")
            .then(function (response) {
                return response.data;
            });
    }
}
